const state = {
  user: null,
  loginCall: {
    inProgress: true,
    message: ''
  }
}

const getters = {
  isUserLoggedIn: state => {
    return state.user
  },
  currentUser: state => {
    return state.user
  },
  loginCallInProgress: state => {
    return state.loginCall.inProgress
  }
}

const mutations = {
  logUserIn: (state, payload) => {
    state.user = payload
  },
  logUserOut: state => {
    state.user = null
  },
  endGetCurrentUserCall: (state, payload) => {
    state.loginCall.inProgress = false
    state.loginCall.message = payload
  }
}

const actions = {

}

export default {
  state,
  getters,
  mutations,
  actions
}
